import { useQuery } from "react-query";
import { apiInstance } from "../config/baseUrl";

export const useSimpleFetch = (key, url) => {
  const accessToken =
    window.localStorage.getItem("token")

  return useQuery({
    queryKey: [key],
    queryFn: async () => {
      const res = await apiInstance({
        method: "GET",
        url,
        headers: {
          tymeplusjwt: accessToken,
        },
      });
      return res.data;
    },
    refetchOnWindowFocus: false,
  });
};